import React, { Fragment, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./../CustomedFields/FormikControl";
import commonServices from "../../Utils/commonServices";
//** get actions from store */
import { useSelector, useDispatch } from "react-redux";
import {
  addOrderInfo,
  updateOrderInfoModeStore,
} from "./../../slice/orderSlice";

// function CustomerAdd(props, ref) {
const CustomerAdd = React.forwardRef((props, ref) => {
  //*** Store */
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderItemsWithMeasurementStore,
    isLoadingStore,
  } = useSelector((state) => state.order);

  // alert("orderAddUpdate-> props.order " + orderStore?.alternetPhoneNo);
  const [orderMaster, setOrderMaster] = useState(props.order);
  const { orderNumber, alternetPhoneNo, orderDate, deliveryDate } = orderMaster;
  const onInputChange = (e) => {
    setOrderMaster({ ...orderMaster, [e.target.name]: e.target.value });
  };

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   await axios.post("https://60decafeabbdd9001722d05c.mockapi.io/users", user);
  //   history.push("/");
  // };

  const initialValues = { orderMaster };

  const validationSchema = Yup.object({
    // alternetPhoneNo: Yup.string().required("Required"),
    orderDate: Yup.date().required("Required"),
    deliveryDate: Yup.date().required("Required"),
    // courseDate: Yup.date().required("Required").nullable(),
  });

  const onSubmit = async (e) => {
    // console.log("Form submitted data");
    // alert("add order info submit");
    props.AddOrderToDB(orderMaster);
  };

  //   const handleSubmit = (event) => {
  //     //event.preventDefault();
  //     //Your code here. For example,
  //     alert("Form submitted");
  //   };

  //********************* Form validation send to Parent form */
  React.useEffect(() => {
    // Update the document title using the browser API
    // alert("document.getElementById(submitButton).disabled");
    props.isValidChildFormInputs(
      document.getElementById("submitButton")?.disabled
    );
  }, [document.getElementById("submitButton")?.disabled]);

  return (
    <Formik
      initialValues={orderMaster || initialValues}
      validationSchema={validationSchema}
      // onSubmit={onSubmit}
      onSubmit={(values) => {
        console.log("values of form submit: " + values);
      }}
      enableReinitialize={true}
    >
      {(formik) => {
        return (
          <form
            onSubmit={(e) => {
              console.log("e, values => : " + e);
              //handleSubmit(e);
              onSubmit(e);
              e.preventDefault();
            }}
          >
            <FormikControl
              control="input"
              type="text"
              label="Order Number"
              name="orderNumber"
              value={orderNumber}
              onChange={(e) => onInputChange(e)}
              disabled="disabled"
            />
            <div style={{ width: "150px", float: "left" }}>
              <FormikControl
                control="input"
                type="date"
                label="Order Date"
                name="orderDate"
                dateFormat="dd/MM/yyyy"
                value={orderDate}
                onChange={(e) => onInputChange(e)}
              />
            </div>
            <div style={{ width: "150px", float: "left" }}>
              <FormikControl
                control="input"
                type="date"
                label="Delivery Date"
                name="deliveryDate"
                dateFormat="dd/MM/yyyy"
                value={deliveryDate}
                onChange={(e) => onInputChange(e)}
              />
            </div>
            <FormikControl
              control="input"
              type="text"
              label="Alternet Phone"
              name="alternetPhoneNo"
              value={alternetPhoneNo}
              onChange={(e) => onInputChange(e)}
            />
            <button
              id="submitButton"
              type="submit"
              disabled={!formik.isValid}
              ref={ref}
              style={{ display: "none" }}
            >
              Submit
            </button>
          </form>
        );
      }}
    </Formik>
  );
});

export default CustomerAdd;
